<script setup lang="ts">
defineProps<{
  as?: string
  wave?: boolean
  pulse?: boolean
  shape?: 'circle' | 'rect' | 'text'
}>()
</script>

<template>
  <Component
    :is="as || 'span'"
    class="n-skeleton" :class="[
      wave ? 'n-skeleton-wave' : pulse ? 'animate-pulse' : 'animate-pulse',
      ({ circle: 'n-skeleton-circle', rect: 'n-skeleton-rect', text: 'n-skeleton-text' })[shape || 'text'],
    ]"
  />
</template>
